import React from "react";
import './styles.css'
function Header() {
  return (
    <div className="header">
      <h1>Online Code Editor</h1>
    </div>
  );
}

export default Header;
